import { Roles } from "src/app/shared/enums/Roles.enum";

/** V3's Risk roles. Today the one: `risk analyst`. */
const RISK_ROLES: readonly string[] = [Roles.RISK_ANALYST];

/**
 * The role the company detail's tab strip is given. The design library (`lib-tab-payer-detail-view`) shows the «Contactos» tab only to `risk analyst`;
 * driver, 2026-10-23 (T623): «Remove it for risk role only» — a contact a user adds in V3 reaches V5 at once, and Risk works its contacts there. So a Risk role is given
 * none (no tab), and every other role is given as it is. The contacts themselves and the add / edit / validate acts stay in the code, for the day the tab returns.
 */
export function roleForCompanyTabs(role: string | undefined | null): string | undefined {
  if (!role) return undefined;
  return RISK_ROLES.includes(role) ? undefined : role;
}
